// @ts-check

import { api } from '@/api'
import { useCompanyStore } from '@/store/company'
import { useMemoize } from '@vueuse/core'
import invariant from 'invariant'

export const getDimensions = async () => {
  const { company } = useCompanyStore()
  invariant(company, 'Company is required')
  return api.get(`company/${company.id}/reporting-dimensions`)
}

/**
 * @type {import('@vueuse/core').UseMemoizeReturn<Promise<ReportingDimensionResource[]>, [{ is_active?: '0' | '1', dimension_type?: string }]>}}
 */
export const getCompanyReportingDimensions = useMemoize(async (params = {}) => {
  /** @type {import('axios').AxiosResponse<ReportingDimensionResource[]>} */
  const { data: dimensions } = await api.get('reporting-dimensions', {
    params
  })
  return dimensions
})

export const createReportingDimension = async (payload) => {
  const { company } = useCompanyStore()
  invariant(company, 'Company is required')
  return api.post(`company/${company.id}/reporting-dimensions`, payload)
}

export const updateReportingDimension = async (id, payload) => {
  const { company } = useCompanyStore()
  invariant(company, 'Company is required')
  return api.patch(`company/${company.id}/reporting-dimensions/${id}`, payload)
}

export const deleteReportingDimension = async (id) => {
  const { company } = useCompanyStore()
  invariant(company, 'Company is required')
  return api.delete(`company/${company.id}/reporting-dimensions/${id}`)
}

export const getActiveDimensions = async () => {
  const { company } = useCompanyStore()
  invariant(company, 'Company is required')
  return api.get(`company/${company.id}/active-reporting-dimensions`)
}
